// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorComponent_errorContainer__fdjvA","errorMessage":"ErrorComponent_errorMessage__w45u7"};